/**
 * 얇은 분석 이벤트 래퍼.
 *
 * 환경변수 `NEXT_PUBLIC_POSTHOG_KEY` 미설정 시 no-op.
 * PostHog `/i/v0/e/` capture endpoint를 fetch로 직접 호출하여 외부 패키지 의존 0.
 *
 * 사용법:
 *   trackEvent('register_success', { source: 'email' });
 *
 * 분석 호출은 절대 사용자 흐름을 막지 않습니다 (모든 에러 swallow).
 */

const POSTHOG_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY ?? '';
const POSTHOG_HOST = process.env.NEXT_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com';

const DISTINCT_ID_KEY = 'ph_distinct_id';

function getOrCreateDistinctId(): string {
  if (typeof window === 'undefined') { return ''; }
  try {
    let id = localStorage.getItem(DISTINCT_ID_KEY);
    if (!id) {
      const cryptoObj = (typeof globalThis !== 'undefined' && 'crypto' in globalThis)
        ? (globalThis.crypto as Crypto | undefined)
        : undefined;
      id = `anon_${cryptoObj?.randomUUID?.() ?? Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(DISTINCT_ID_KEY, id);
    }
    return id;
  } catch {
    return `anon_${Date.now().toString(36)}`;
  }
}

export function identifyUser(userId: string): void {
  if (typeof window === 'undefined') { return; }
  try {
    localStorage.setItem(DISTINCT_ID_KEY, userId);
  } catch {
    /* swallow */
  }
}

export function trackEvent(name: string, props?: Record<string, unknown>): void {
  if (!POSTHOG_KEY || typeof window === 'undefined') { return; }
  try {
    fetch(`${POSTHOG_HOST}/i/v0/e/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        api_key: POSTHOG_KEY,
        event: name,
        distinct_id: getOrCreateDistinctId(),
        properties: {
          ...props,
          $current_url: window.location.href,
          timestamp: new Date().toISOString(),
        },
      }),
      keepalive: true,
    }).catch(() => { /* swallow */ });
  } catch {
    /* swallow — analytics는 사용자 흐름을 막지 않는다 */
  }
}
